<div *ngIf="appService.theme$ | async as theme">
  <p-menu class="menu-content" [model]="menuItems" [dt]="menuPanel">
       <ng-template pTemplate="menuItem" let-item>
           <ng-container>
            <div class="row">
            </div>
            <a [routerLink]="item.route" class="menu-item-row"
              [style]="{'border-left': (item.selected===true) ? 
              '4px solid var(--p-primary-600)' : '4px solid var(--p-surface-0)',
              'background': (item.selected ===true) ? 'var(--p-surface-100)' : 'transparent'}">
              @if (item.label == 'Flights') {
               <img style="width: 17px; height: 17px"
                 [src]="theme == 'light' ? item.iconLight : item.iconDark" />
              }
              @else {
               @if(navSignalsService.badgeCountActive$() && item.label == 'About') {
                  <p-overlayBadge severity="danger">
                    <i [class]="item.icon" style="width: 17px; height: 17px"></i>
                  </p-overlayBadge>
               }
               @else {
                 <i [class]="item.icon" style="width: 17px; height: 17px"></i>
               }
              }
              <div>{{ item.label }}</div>
            </a>
           </ng-container>
       </ng-template>
     </p-menu>
</div>
